import { ApiClient } from 'ApiClient';
import { Reservation, ReservationStatus } from 'interfaces';

class ReservationService {
  public async getAll(query?: {
    status?: ReservationStatus;
    date?: string;
    search?: string;
  }): Promise<Reservation[]> {
    const params: { [key: string]: string | number } = {};
    if (query?.status) params.status = query.status;
    if (query?.date) params.date = query.date;
    if (query?.search) params.search = query.search;
    return ApiClient.get<Reservation[]>('reservations', params);
  }

  /**
   * The outlets a booking can be made for. Public endpoint, shared with the
   * website form so both offer the same names.
   */
  public async getOutlets(): Promise<Array<{ id: number; name: string }>> {
    return ApiClient.get<Array<{ id: number; name: string }>>('reservations/outlets');
  }

  public async getById(id: number): Promise<Reservation> {
    return ApiClient.get<Reservation>(`reservations/${id}`);
  }

  public create(data: any) {
    return ApiClient.post('reservations', data);
  }

  public update(id: number, data: any) {
    return ApiClient.put(`reservations/${id}`, data);
  }

  public remove(id: number) {
    return ApiClient.delete(`reservations/${id}`);
  }

  public async getAvailability(
    date: string,
    experienceId?: number,
  ): Promise<{ date: string; slots: string[]; reason?: string }> {
    const params: { [key: string]: string | number } = { date };
    if (experienceId) params.experience_id = experienceId;
    return ApiClient.get<{ date: string; slots: string[]; reason?: string }>(
      'reservations/availability',
      params,
    );
  }
}

const singleton = new ReservationService();
export { singleton as ReservationService };
